<dt-modal-content (closeClick)="close()">
  <ng-template #title>
    @if (tag) {
      <ng-container i18n>Tag bearbeiten</ng-container>
    } @else {
      <ng-container i18n>Tag hinzufügen</ng-container>
    }
  </ng-template>
  <ng-template #content>
    <form [formGroup]="formGroup" (ngSubmit)="save()">
      <div>
        <mat-form-field>
          <mat-label i18n>Deutscher Name</mat-label>
          <input matInput type="text" formControlName="nameDe" />
        </mat-form-field>
        <mat-form-field>
          <mat-label i18n>Englischer Name</mat-label>
          <input matInput type="text" formControlName="nameEn" />
        </mat-form-field>
        <mat-form-field>
          <mat-label i18n>Gewicht</mat-label>
          <input matInput type="number" min="0" step="1" formControlName="weight" />
          @if (formGroup.controls.weight.invalid) {
            <mat-error i18n>Bitte gib eine positive Ganzzahl ein</mat-error>
          }
        </mat-form-field>
        @if (tag) {
          <div class="tag-id">
            <span i18n>Tag-ID: &nbsp;</span><span class="grey">{{ formGroup.controls.id.value }}</span>
            <button mat-icon-button type="button" [cdkCopyToClipboard]="tag.id" matTooltip="Tag-ID kopieren" i18n-matTooltip>
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
        }
      </div>

      <div class="buttons-wrapper">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [dtOverlayProgress]="formGroup.disabled"
          [disabled]="formGroup.disabled || formGroup.invalid"
          i18n
          >Speichern</button
        >
        <button mat-stroked-button type="reset" (click)="close()" [disabled]="formGroup.disabled" i18n>Verwerfen</button>
        @if (tag) {
          <button mat-stroked-button color="warn" type="button" (click)="delete()" [disabled]="formGroup.disabled" i18n>Tag löschen</button>
        }
      </div>
    </form>
  </ng-template>
</dt-modal-content>
